export enum SpinnerTypes {
    Ball8bits = 'ball-8bits',
    BallAtom = 'ball-atom',
    BallBeat = 'ball-beat',
    BallCircus = 'ball-circus',
    BallClimbingDot = 'ball-climbing-dot',
    BallClipRotate = 'ball-clip-rotate',
    BallClipRotateMultiple = 'ball-clip-rotate-multiple',
    BallClipRotatePulse = 'ball-clip-rotate-pulse',
    BallElasticDots = 'ball-elastic-dots',
    BallFall = 'ball-fall',
    BallFusion = 'ball-fussion',
    BallGridBeat = 'ball-grid-beat',
    BallGridPulse = 'ball-grid-pulse',
    BallNewtonCradle = 'ball-newton-cradle',
    BallPulse = 'ball-pulse',
    BallPulseRise = 'ball-pulse-rise',
    BallPulseSync = 'ball-pulse-sync',
    BallRotate = 'ball-rotate',
    BallRunningDots = 'ball-running-dots',
    BallScale = 'ball-scale',
    BallScaleMultiple = 'ball-scale-multiple',
    BallScalePulse = 'ball-scale-pulse',
    BallScaleRipple = 'ball-scale-ripple',
    BallScaleRippleMultiple = 'ball-scale-ripple-multiple',
    BallSpin = 'ball-spin',
    BallSpinClockwise = 'ball-spin-clockwise',
    BallSpinClockwiseFade = 'ball-spin-clockwise-fade',
    BallSpinClockwiseFadeRotating = 'ball-spin-clockwise-fade-rotating',
    BallSpinFade = 'ball-spin-fade',
    BallSpinFadeRotating = 'ball-spin-fade-rotating',
    BallSpinRotate = 'ball-spin-rotate',
    BallSquareClockwiseSpin = 'ball-square-clockwise-spin',
    BallSquareSpin = 'ball-square-spin',
    BallTrianglePath = 'ball-triangle-path',
    BallZigZag = 'ball-zig-zag',
    BallZigZagDeflect = 'ball-zig-zag-deflect',
    Cog = 'cog',
    CubeTransition = 'cube-transition',
    Fire = 'fire',
    LineScale = 'line-scale',
    LineScaleParty = 'line-scale-party',
    LineScalePulseOut = 'line-scale-pulse-out',
    LineScalePulseOutRapid = 'line-scale-pulse-out-rapid',
    LineSpinClockwiseFade = 'line-spin-clockwise-fade',
    LineSpinClockwiseFadeRotating = 'line-spin-clockwise-fade-rotating',
    LineSpinFade = 'line-spin-fade',
    LineSpinFadeRotating = 'line-spin-fade-rotating',
    Pacman = 'pacman',
    SquareJellyBox = 'square-jelly-box',
    SquareLoader = 'square-loader',
    SquareSpin = 'square-spin',
    Timer = 'timer',
    TriangleSkewSpin = 'triangle-skew-spin'
}
